import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Container } from 'theme-ui'

import { TextWitListItemProps } from './types'
import media from './../../../common/MediaQueries'
import { WithTheme } from './../../../setup/index'
import { NumbersListItemStyled } from './../../molecules/NumbersList/styles'

export const TextWithListStyled = styled.div``

export const TextWithListTitleStyled = styled.div``

export const TextWithListSubtitleStyled = styled.div`
  margin-top: 2rem;
`

export const TextWithListContentStyled = styled.div`
  max-width: 58.125rem;
  margin: 4rem auto 0;
`

export const TextWithListNumbersStyled = styled.div`
  width: 100%;
  margin-top: 4rem;
  margin-bottom: 3.375rem;
  @media ${media.phone} {
    margin-bottom: 6.5rem;
    margin-top: 6.25rem; // changed to make all sections uniform
  }
`

export const TextWithListActionStyled = styled.div`
  display: flex;
  flex-direction: column;
`

export const TextWithListInnerStyled = styled(Container)<WithTheme<TextWitListItemProps>>`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  ${({ isAlignLeft, theme }) =>
    isAlignLeft &&
    css`
      @media ${media.phone} {
        align-items: flex-start;
      }
      ${TextWithListContentStyled} {
        @media ${media.phone} {
          ${theme.direction === 'rtl' ? 'margin-right: 0;' : 'margin-left: 0;'}
          ${theme.direction === 'rtl' ? 'text-align: right;' : 'text-align: left;'}
        }
        max-width: 32.75rem;
        margin-top: 2.125rem;
      }
      ${NumbersListItemStyled} {
        > * {
          max-width: 100%;
        }
        &:not(:first-of-type)::before {
          top: 0;
        }
      }
    `};
`
